module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[106]471.d0d7006.woff2";